module.exports = __webpack_public_path__ + "static/media/itsuki_active19fe1928c3b6cb2363be5cac72e72af3.webp";